<div class="modal-header">
  <h5 class="modal-title">Version History</h5>
  <button class="fa fa-times" [mat-dialog-close]="" style="float: right;cursor: pointer;background: none;border:none"
    aria-hidden="true"></button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-md-3 text-left p-0">
      <div class="text-blue ml-3" *ngIf="(versionHistory && (versionHistory.length>0))">
        <div>{{endIndex}} out of {{totalCount}}</div>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="table-responsive box-shadow">
        <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
        <table class="table table-fixed table-striped table-hover mb-1 table-width">
          <thead style="padding-right: 5px;">
            <tr>
              <th class="pointer col-lg-1 mx-width-10pr text-center" (click)="sortVersionHistory('Id')">Id
                <i class="fa" [ngClass]="{'fa-sort-amount-asc': (versionHistoryFilter.SortKey === 'Id' && !versionHistoryFilter.IsDesc),
          'fa-sort-amount-desc': (versionHistoryFilter.SortKey === 'Id' && versionHistoryFilter.IsDesc) }"
                  aria-hidden="true">
                </i>
              </th>
              <th class="pointer col-lg-2 mx-width-22pr text-center" (click)="sortVersionHistory('VersionNumber')">
                Version Number
                <i class="fa" [ngClass]="{'fa-sort-amount-asc': (versionHistoryFilter.SortKey === 'VersionNumber' && !versionHistoryFilter.IsDesc),
          'fa-sort-amount-desc': (versionHistoryFilter.SortKey === 'VersionNumber' && versionHistoryFilter.IsDesc) }"
                  aria-hidden="true">
                </i>
              </th>
              <th class="pointer col-lg-2 mx-width-22pr text-center" (click)="sortVersionHistory('VersionDate')">Date of
                Version
                <i class="fa" [ngClass]="{'fa-sort-amount-asc': (versionHistoryFilter.SortKey === 'VersionDate' && !versionHistoryFilter.IsDesc),
          'fa-sort-amount-desc': (versionHistoryFilter.SortKey === 'VersionDate' && versionHistoryFilter.IsDesc) }"
                  aria-hidden="true">
                </i>
              </th>
              <th class="pointer col-lg-1 mx-width-22pr text-center" (click)="sortVersionHistory('UserName')">User
                <i class="fa" [ngClass]="{'fa-sort-amount-asc': (versionHistoryFilter.SortKey === 'UserName' && !versionHistoryFilter.IsDesc),
          'fa-sort-amount-desc': (versionHistoryFilter.SortKey === 'UserName' && versionHistoryFilter.IsDesc) }"
                  aria-hidden="true">
                </i>
              </th>
              <th class="pointer col-lg-1 mx-width-22pr text-center">Action</th>
            </tr>
          </thead>
          <tbody *ngIf="(versionHistory && (versionHistory.length> 0))" [style.max-height.px]="myInnerHeight">
            <cdk-virtual-scroll-viewport class="list-container list-group" itemSize="35"
              (scrolledIndexChange)="handler($event)" [style.height.px]="myInnerHeight"
              *ngIf="versionHistory.length > 0">
              <div *cdkVirtualFor="let item of versionHistory; let i = index">
                <tr
                  [ngClass]="(resultViewData.versionId === item.id && resultViewData.filterType === 'version')? 'd-highlight' : ''">
                  <td class="pointer col-lg-1 mx-width-10pr text-center">{{item.id}}</td>
                  <td class="pointer col-lg-1 mx-width-22pr text-center">{{item.versionNumber}}</td>
                  <td class="pointer col-lg-1 mx-width-22pr text-center">{{item.versionDate | date:'dd-MMM-yyyy'}}</td>
                  <td class="pointer col-lg-1 mx-width-22pr text-center">{{item.userName}}</td>
                  <td class="pointer col-lg-1 mx-width-22pr text-center">
                    <a *ngIf="templateNo == 1" href="/self-assessment/details/version/{{item.id}}">View</a>
                    <a *ngIf="templateNo == 2" href="/self-assessment/details/version/2/{{item.id}}">View</a>
                    <a *ngIf="templateNo == 3" (click)="viewVersionHistory(resultViewDataT3.versionType, item.id, item.versionNumber)">View</a>
                  </td>
                </tr>
              </div>
            </cdk-virtual-scroll-viewport>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
